export const defaultFirebaseValues: FirebaseRemoteConfigDefaultValues = {
  remoteConfigTest: 'Default value from remote config',
};
